import { render, staticRenderFns } from "./previewData.vue?vue&type=template&id=f3926502&"
import script from "./previewData.vue?vue&type=script&lang=js&"
export * from "./previewData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports